import { render, staticRenderFns } from "./CountriesList.vue?vue&type=template&id=458baa34&scoped=true&"
import script from "./CountriesList.vue?vue&type=script&lang=js&"
export * from "./CountriesList.vue?vue&type=script&lang=js&"
import style0 from "./CountriesList.vue?vue&type=style&index=0&id=458baa34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458baa34",
  null
  
)

export default component.exports